<!-- Carte à trouver -->
<app-card-to-find-in-game class="absolute top-0" ></app-card-to-find-in-game>

<!--Text de presentation-->
<app-game-text-presentation></app-game-text-presentation>

<!-- text de fin de jeu -->
<app-game-end-text class="absolute top-0"></app-game-end-text>

<!-- Compte a rebours-->
<app-count-down class="absolute top-0"></app-count-down>

<!-- Affoichage de mot -->
<app-word-action class="absolute top-0"></app-word-action>

<app-main-container>

  <div class="flex flex-column w-full over">
    <!-- Message erreur de chargement-->
   <div class="flex justify-content-center h-3rem">
     <div *ngIf="(isGameLoadingSuccess$ | async) === false && (isGameReadyToPlay$ | async)">
       <p-message severity="error"> Oups le jeu ne s'est pas chargé correctement. </p-message>
     </div>
   </div>

   <div class="w-full flex align-items-center justify-content-center" *ngIf="(isGameLoadingSuccess$ | async) === true">
     <!-- jeux de cartes-->
     <div class="grid w-full md:p-5">
       <app-card class="col-4 p-1 md:col-2" [isGameReadyToPlay]="(isGameReadyToPlay$ | async)" [card]=card *ngFor="let card of cards$ | async; trackBy: trackByCardId"></app-card>
     </div>
   </div>
  </div>
</app-main-container>
